
(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeSidebarController', Controller);

    Controller.$inject = ['$scope', 'employee', 'authenticatedUser'];

    function Controller($scope, employee, authenticatedUser) {
        $scope.employee = employee;
        $scope.authenticatedUser = authenticatedUser;

        $scope.toggleSystemOwnedMenu = function () {
            $scope.showSystemOwnedMenu = !$scope.showSystemOwnedMenu;
        };
    }
})();